import { memo, useCallback, useMemo } from "react";

import { cn } from "@/lib/chillnn/cn";
import type { PlainReservationComponentType } from "@/lib/gql/__generated__/graphql";

import { LikeReservationComponent } from "@/components/features/design/plain/ui/components/main/like-reservation-component";

type Props = {
	primaryColor: string;
	target: PlainReservationComponentType;
	current: PlainReservationComponentType;

	onClickCard: (value: PlainReservationComponentType) => void;
};

export const LikeReservationComponentCard = memo(({ primaryColor, target, current, onClickCard }: Props) => {
	const handleClickCard = useCallback(() => {
		onClickCard(target);
	}, [onClickCard, target]);

	const active = useMemo(() => current === target, [current, target]);

	return (
		<div
			className={cn(
				"box-border h-full w-full min-w-72 max-w-xs cursor-pointer rounded-lg border-[3px] border-zinc-400 p-2 hover:opacity-60 ",
				active && "border-brand",
			)}
			onClick={handleClickCard}
		>
			<LikeReservationComponent primaryColor={primaryColor} plainReservationComponentType={target} />
		</div>
	);
});
